import { anonymousRoutes } from "@/routes/configs/anonymous.routes.tsx";
import { authenticatedRoutes } from "@/routes/configs/authenticated.routes.tsx";
import { RouteConfig } from "@/routes/types/route.types.ts";
import { useMemo } from "react";
import { matchRoutes, useLocation } from "react-router-dom";

export const useAppRoutes = () => {
  const location = useLocation();

  const routes = useMemo(() => {
    const allRoutes: RouteConfig[] = [...anonymousRoutes, ...authenticatedRoutes];

    const flattenRoutes = (routes: RouteConfig[], parentPath = ""): RouteConfig[] => {
      return routes.flatMap((route: RouteConfig) => {
        if (route.redirect) {
          return [];
        }

        const routePath = route.path?.startsWith("/") ? route.path.substring(1) : route.path;
        const path =
          parentPath && routePath ? `${parentPath}/${routePath}` : parentPath || routePath || "";

        const flatRoute = {
          ...route,
          path,
        };

        if (route.children && route.children.length > 0) {
          return [flatRoute, ...flattenRoutes(route.children, path)];
        }

        return [flatRoute];
      });
    };
    return flattenRoutes(allRoutes);
  }, []);

  const matchedRoutes = useMemo(
    () => matchRoutes<RouteConfig>(routes, location.pathname),
    [routes, location.pathname]
  );

  const isFullScreenRoute = useMemo(
    () => matchedRoutes?.some(({ route }) => route.isFullScreen === true),
    [matchedRoutes]
  );

  const sidebarIsShowing = useMemo(
    () => matchedRoutes?.some(({ route }) => route.isHideSidebar !== true),
    [matchedRoutes]
  );

  return { isFullScreenRoute, sidebarIsShowing };
};
